import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_NAME = "Pure Investments";
const SUPPORTED = ["de", "en"];

function upsertMeta(key, content, attr) {
  if (!content) return;
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href, hreflang) {
  const selector = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const Seo = ({ title, description, image }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const fullTitle = title ? `${title}` : SITE_NAME;
    document.title = fullTitle;
    upsertMeta("description", description, "name");

    const origin = window.location.origin;
    const segment = pathname.split("/")[1];
    const lang = SUPPORTED.includes(segment) ? segment : "de";
    const rest = pathname.replace(/^\/(de|en)/, "");
    const canonical = `${origin}/${lang}${rest}`;
    const imageUrl = `${origin}${image || "/og-image.jpg"}`;

    upsertLink("canonical", canonical);
    upsertLink("alternate", `${origin}/de${rest}`, "de");
    upsertLink("alternate", `${origin}/en${rest}`, "en");
    upsertLink("alternate", `${origin}/de${rest}`, "x-default");

    upsertMeta("og:site_name", SITE_NAME, "property");
    upsertMeta("og:title", fullTitle, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:type", "website", "property");
    upsertMeta("og:url", canonical, "property");
    upsertMeta("og:locale", lang === "de" ? "de_AT" : "en_US", "property");
    upsertMeta("og:image", imageUrl, "property");
    upsertMeta("twitter:card", "summary_large_image", "name");
    upsertMeta("twitter:title", fullTitle, "name");
    upsertMeta("twitter:description", description, "name");
    upsertMeta("twitter:image", imageUrl, "name");
  }, [title, description, image, pathname]);

  return null;
};

export default Seo;
